import { convertCellEventList } from '@/common/converter/convert-event-list'
import { getContextProperty } from '@/common/utils/home/get-context-property'

/**
 * home + catalog 데이터를 조합할 때
 * source 가 되는데 필요한 element 요소들을 결합하여 반환한다.
 * @param elementList
 * @returns {{eventList: ({cta: string, add_timestamp: string, method: string, add_common_params: string, bodylist: *, add_credential: string, type: string, url: *}|{}|{type: string, url: string, method: string, bodylist: [], add_common_params: string, add_timestamp: string, add_credential: string}|undefined)[], contextProperty: *}}
 */
export const sourceAccumulator = (elementList = []) => {
  const eventList = convertCellEventList(elementList)
  const contextProperty = getContextProperty(elementList)

  return {
    eventList,
    contextProperty,
  }
}
